export default __webpack_public_path__ + "static/media/Lumbie_Mlambo_AHV_In_Moms_We_Trust.b16bb39b.jpg";